export const ERROR_CONNECT_TOOL_USB =
  "Lỗi kết nối. Vui lòng kiểm tra lại file kết nối và ấn restart lại";
export const ERROR_GET_INFO_USB =
  "Không lấy dc thông tin USB token. Vui lòng kiểm tra lại USB và ấn Recheck";
export const GET_INFO_USB = "Đang lấy thông tin USB token";

export const FIELD_EXTRA = {
  FIELD_EMPTY: {
    field: "FIELD_EMPTY",
  },
};

export const ISSUE_INVOICE_COMMON_FIELD = {
  NOTE: {
    field: "note", // ghi chú
    type: "text",
    required: false,
  },
  PBAN: {
    field: "pban", // Phiên Bản
    type: "text",
    max: 6,
    disabled: true,
    isHide: true,
    required: false,
  },
  TTCHUNG_KHHDON: {
    xs: 2,
    field: "ttchung_khhdon", // Ký hiệu hóa đơn
    type: "text",
    // isKHHD: true,
    max: 6,
    required: false,
    disabled: true,
    order: 1,
    styleInput: {
      borderBottom: "none",
      //   marginLeft: "-27px",
      paddingLeft: "0px",
    },
  },
  TTCHUNG_KHMSHDON: {
    field: "ttchung_khmshdon", // Ký hiệu mẫu số hóa đơn
    type: "text",
    isShowLabel: false,
    selectValues: {
      VAT_INVOICE: "1",
      SALE_INVOICE: "2",
      TICKETS_INVOICE: "5",
      DELIVERY_BILL: "6",
      WAREHOUSE_AGENCY: "6",
    },
    max: 1,
    required: false,
    disabled: true,
    order: 5,
    styleInput: {
      borderBottom: "none",
      marginLeft: "-27px",
    },
  },
  TTCHUNG_SHDON: {
    xs: 2,
    field: "ttchung_shdon", // Số hóa đơn
    type: "text",
    required: false,
    disabled: true,
    order: 5,
    styleInput: {
      borderBottom: "none",
      marginLeft: "-27px",
      color: "red",
    },
  },
  TTCHUNG_NLAP: {
    xs: 4,
    field: "ttchung_nlap", // Ngày lập
    type: "date",
    required: true,
    disabled: false,
    marginLeft: "-27px",
    order: 5,
    styleInput: {
      marginLeft: "-37px",
    },
  },
  TTCHUNG_DVTTE: {
    field: "ttchung_dvtte", // Đơn vị tiền tệ
    type: "select",
    max: 3,
    required: true,
    order: 5,
    widthLabel: "192px",
  },
  TTCHUNG_TGIA: {
    field: "ttchung_tgia", // Tỷ giá
    type: "number",
    max: 7,
    disabled: false,
    required: false,
    order: 5,
    widthLabel: "192px",
  },
  TTCHUNG_THDON: {
    field: "ttchung_thdon", // Tên Hóa Đơn
    type: "text",
    isHide: false,
    disabled: true,
    max: 100,
    required: false,
    order: 1,
    isShowLabel: false,
    xs: 4,
    styleInput: {
      borderBottom: "none",
      fontWeight: "500",
      fontSize: "20px",
      marginLeft: "-9px",
    },
  },
  TTCHUNG_MSTTCGP: {
    field: "ttchung_msttcgp", // Mã số thuế tổ chức cung cấp giải pháp hóa đơn điện tử
    type: "text",
    isHide: true,
    max: 14,
    required: false,
    order: 5,
  },
  TTChung_TTKhac: {
    field: "ttchung_ttkhac", // Thông tin chung khác
    type: "object",
    max: 255,
    isHide: true,
    required: false,
  },
};

export const ISSUE_INVOICE_SELLER_FIELD = {
  NBAN_TEN: {
    xs: 6,
    field: "nban_ten", // Tên
    type: "text",
    max: 400,
    disabled: false,
    required: true,
    isShowLabel: false,
    styleInput: {
      borderBottom: "none",
      fontWeight: "bold",
      fontSize: "15px",
      marginLeft: "-9px",
    },
  },
  NBAN_MST: {
    xs: 6,
    field: "nban_mst", // Mã số thuế
    type: "text",
    isTaxCode: false,
    max: 14,
    disabled: false,
    required: true,
    widthLabel: "210px",
    styleInput: {
      borderBottom: "none",
      marginLeft: "-27px",
      fontWeight: "600",
      letterSpacing: "1px",
    },
  },
  NBAN_HDKTSO: {
    field: "nban_hdktso", // Hợp đồng kinh tế số
    type: "text",
    max: 255,
    disabled: false,
    required: true,
    widthLabel: "192px",
  },
  NBAN_HDKTNGAY: {
    field: "nban_hdktngay", // Hợp đồng kinh tế ngày
    type: "date",
    required: true,
    disabled: false,
    widthLabel: "192px",
    styleRow: {
      marginTop: "8px",
    },
  },
  NBAN_DCHI: {
    field: "nban_dchi", // Địa chỉ kho xuất hàng
    type: "text",
    max: 400,
    disabled: false,
    required: true,
    // styleInput: {
    //   borderBottom: "none",
    //   marginLeft: "-27px",
    // },
    widthLabel: "192px",
  },
  NBAN_HDSO: {
    field: "nban_hdso", // Hợp đồng số
    type: "text",
    max: 255,
    disabled: false,
    required: false,
    widthLabel: "192px",
  },
  NBAN_HVTNXHANG: {
    field: "nban_hvtnxhang", // Họ và tên người xuất hàng
    type: "text",
    max: 100,
    disabled: false,
    required: false,
    widthLabel: "192px",
  },
  NBAN_TNVCHUYEN: {
    field: "nban_tnvchuyen", // Tên người vận chuyển
    type: "text",
    max: 100,
    disabled: false,
    required: true,
    widthLabel: "192px",
  },
  NBAN_PTVCHUYEN: {
    field: "nban_ptvchuyen", // Phương tiện vận chuyển
    type: "text",
    max: 50,
    disabled: false,
    required: true,
    widthLabel: "192px",
  },
  NBAN_TTKHAC: {
    field: "nban_ttkhac", // Thông tin khác
    type: "text",
    isHide: true,
    max: 255,
    disabled: true,
    required: false,
  },
};

export const ISSUE_INVOICE_BUYER_FIELD = {
  NMUA_TEN: {
    field: "nmua_ten", // Tên đơn vị nhận hàng
    type: "text",
    max: 400,
    required: true,
    xs: 8,
    widthLabel: "192px",
  },
  NMUA_MST: {
    field: "nmua_mst", // Mã số thuế
    isTaxCode: true,
    type: "text",
    max: 14,
    widthLabel: "192px",
  },
  NMUA_DCHI: {
    field: "nmua_dchi", // Địa chỉ kho nhận hàng
    type: "text",
    max: 400,
    xs: 8,
    required: true,
    widthLabel: "192px",
  },
  NMUA_HVTNNHANG: {
    field: "nmua_hvtnnhang", // Họ và tên người nhận hàng
    type: "text",
    max: 100,
    widthLabel: "192px",
  },
  NMua_TTKhac: {
    field: "nmua_ttkhac", // Thông tin khác
    type: "text",
    max: 255,
    isHide: true,
    require: false,
  },
};

// Danh sách hàng hóa dịch vụ
export const ISSUE_INVOICE_HHDV_FIELD = {
  HHDV_OBJ: {
    field: "hhdv_obj",
    type: "field_array",
    fieldReal: "listInvoiceDetail",
    list: {
      TCHAT: {
        field: "tchat", // Tính chất
        fieldReal: "tchat",
        type: "select",
        selectValues: {
          GOODS: "1", // hàng hóa dịch vụ
          PROMOTION: "2", // khuyến mãi
          DISCOUNT: "3", // chiết khấu thương mại
          EXPLAIN: "4", // Ghi chú diễn giải
          SPECIALIZATION_GOODS: "5", // Hàng hóa đặc trưng
        },
        max: 1,
        width: "300px",
        required: true,
      },
      STT: {
        field: "stt", // Số thứ tự
        fieldReal: "stt",
        type: "number",
        isHide: true,
        required: false,
        max: 4,
      },
      MHHDVU: {
        field: "mhhdvu", // Mã hàng hóa, dịch vụ
        fieldReal: "mhhdvu",
        type: "text",
        max: 50,
        width: "200px",
        isHide: true,
        allowCreate: true,
        required: false,
      },
      THHDVU: {
        field: "thhdvu", // Tên hàng hóa, dịch vụ, diễn giải
        fieldReal: "thhdvu",
        // type: "text",
        max: 500,
        width: "400px",
        type: "text",
        allowCreate: true,
        required: true,
      },
      DVTINH: {
        field: "dvtinh", // Đơn vị tính
        fieldReal: "dvtinh",
        type: "text",
        max: 50,
        width: "300px",
        required: false,
      },
      SLUONG: {
        field: "sluong", // Số lượng
        fieldReal: "sluong",
        type: "number",
        width: "200px",
        isThousandSeparator: true,
        max: 21,
        required: false,
      },
      DGIA: {
        field: "dgia", // Đơn giá
        fieldReal: "dgia",
        type: "number",
        width: "200px",
        isThousandSeparator: true,
        max: 21,
        required: false,
      },
      //   TLCKHAU: {
      //     field: "tlckhau", // Tỷ lệ % chiết khấu
      //     fieldReal: "tlckhau",
      //     type: "number",
      //     isThousandSeparator: true,
      //     width: "200px",
      //     maxValue: 100,
      //     required: false,
      //   },
      //   STCKHAU: {
      //     field: "stckhau", // Số tiền chiết khấu
      //     fieldReal: "stckhau",
      //     type: "number",
      //     isThousandSeparator: true,
      //     width: "200px",
      //     max: 21,
      //     required: false,
      //   },
      //   TSUAT: {
      //     field: "tsuat", // Thuế suất
      //     fieldReal: "tsuat",
      //     type: "select",
      //     width: "200px",
      //     allowCreate: true,
      //     isShowWithPageView: [
      //       issueInvoicePageViewList.PAGE_VAT_INVOICE_HAVE_CODE,
      //       issueInvoicePageViewList.PAGE_VAT_INVOICE_NONE_CODE,
      //       issueInvoicePageViewList.PAGE_INVOICE_TICKETS_HAVE_CODE,
      //       issueInvoicePageViewList.PAGE_INVOICE_TICKETS_NONE_CODE,
      //     ],
      //     max: 11,
      //     required: false,
      //   },
      THTIEN: {
        field: "thtien", // Thành tiền
        fieldReal: "thtien",
        width: "300px",
        type: "number",
        isThousandSeparator: true,
        max: 21,
        disabled: true,
        required: false,
      },
      TTKHAC: {
        field: "ttkhac", // Thông tin khác
        fieldReal: "ttkhac",
        type: "text",
        isHide: true,
        required: false,
        max: 255,
      },
    },
  },
};

export const TYPE_INVOICE_ANOTHER = {
  INVOICE_TICKETS: "INVOICE_TICKETS",
  DELIVERY_BILL: "DELIVERY_BILL",
  WAREHOUSE_AGENCY: "WAREHOUSE_AGENCY",
};

export const MODE_INVOICE_ACTION = {
  REPLACE: "REPLACE",
  ADJUST: "ADJUST",
};

export const TYPE_ADJUST_INVOICE = {
  INCREASE: 1,
  DECREASE: 2,
  CHANGE_INFO: 3,
};

export const FIELD_DISABLE_CONFIG = {
  hhdv_obj: {
    tchat: true,
    mhhdvu: true,
    thhdvu: true,
    dvtinh: false,
    sluong: true,
    dgia: true,
    tlckhau: true,
    stckhau: true,
    tsuat: true,
    thtien: true,
  },
};
